export const createParticipantsRequests = (client) => ({
    listParticipants: async (params) => {
        const { data, meta, links } = await client.api.get("participants", {
            params: params,
        });
        return { data, meta, links };
    },
});
//# sourceMappingURL=index.js.map